import React from "react";
import Flx from "../../../components/layout/Flx";
import Txt from "../../../components/typography/Txt";
import { Divider, useTheme } from "@mui/material";
import Htag from "../../../components/typography/Htag";
const ProfileSection = ({
  title,
  icon,
  children,
  activeTab,
  endContent,
  gap = 1.5,
  description,
  sx,
}) => {
  const theme = useTheme();
  const isMobile = useTheme().breakpoints.down("sm");

  // if (activeTab !== title && activeTab !== "All Information") {
  //   return null;
  // }

  const headerContent = (
    <Flx column sx={{ flexGrow: 1 }} gap={1}>
      <Flx
        gap={0.4}
        ac
        sx={{
          ".MuiSvgIcon-root": {
            fontSize: "18px",
          },
        }}
      >
        {icon}
        <Htag variant="h2" className="text-center">
          {title}
        </Htag>
      </Flx>
      {description ? <Txt secondary>{description}</Txt> : null}
    </Flx>
  );
  return (
    <>
      <Flx column fw gap={gap} sx={{ py: 4, ...sx }}>
        {endContent ? (
          <Flx wrap gap={2} ac className={"section-header"}>
            {headerContent}
            {endContent}
          </Flx>
        ) : (
          headerContent
        )}
        {children}
      </Flx>
      {activeTab === "All Information" ? <Divider sx={{ my: 6 }} /> : null}
    </>
  );
};

export default ProfileSection;
